// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| EzClocker Image UX CSS Classes
| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
.ezImages-avatar-24x24 {
  height: 24px;
  border-radius: 3px;
  background-image: url("/public/images/avatars/ezclocker-engineer-orange.svg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.ezImages-avatar-32x32 {
  height: 32px;
  border-radius: 3px;
  background-image: url("/public/images/avatars/ezclocker-engineer-orange.svg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.ezImages-avatar-64x64 {
  height: 64px;
  border-radius: 3px;
  background-image: url("/public/images/avatars/ezclocker-engineer-orange.svg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.ezImages-avatar-128x128 {
  height: 128px;
  border-radius: 3px;
  background-image: url("/public/images/avatars/ezclocker-engineer-orange.svg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.ezImages-small-help {
  padding: 0;
  border: 0;
  width: 18px;
  background-image: url("/public/images/icons/info.svg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

.ezImages-actiongreen-check-left-container-24x24 {
  display: inline-block;
  padding: 0 0 0 30px;
  min-width: 28px;
  background-image: url("/public/images/icons/check-ezActionGreen.svg");
  background-position: left center;
  background-repeat: no-repeat;
  background-size: 24px 24px;
}

.ezImages-black-check-left-container-24x24 {
  display: inline-block;
  padding: 0 0 0 30px;
  min-width: 28px;
  background-image: url("/public/images/icons/check-black.svg");
  background-position: left center;
  background-repeat: no-repeat;
  background-size: 24px 24px;
}

.ezImages-black-check-left-container-18x18 {
  display: inline-block;
  padding: 0 0 0 30px;
  min-width: 28px;
  background-image: url("/public/images/icons/check-black.svg");
  background-position: left center;
  background-repeat: no-repeat;
  background-size: 18px 18px;
}

.ezImages-hamburger-menu-button {
  display: inline-block;
  margin: 2px;
  padding: 0 0 0 30px;
  min-width: 24px;
  min-height: 24px;
  background-color: var(--ezClockerNavy);
  background-image: url("/public/images/icons/mobile-menu-white.svg");
  background-position: left center;
  background-repeat: no-repeat;
  background-size: 18px 18px;
}

.ezImages-square-micro-icon-8x8 {
  text-align: left;
  padding: 0;
  margin: 0;
  width: 8px;
  height: 8px;
  border-style: none;
}

.ezImages-square-mini-icon-10x10 {
  text-align: left;
  padding: 0;
  margin: 0;
  width: 10px;
  height: 10px;
  border-style: none;
}

.ezImages-square-small-icon-16x16 {
  text-align: left;
  padding: 0;
  margin: 0;
  width: 16px;
  height: 16px;
  border-style: none;
}

.ezImages-square-medium-icon-18x18 {
  text-align: left;
  padding: 0;
  margin: 0;
  width: 18px;
  height: 18px;
  border-style: none;
}

.ezImages-square-normal-icon-22x22 {
  text-align: left;
  padding: 0;
  margin: 0;
  width: 22px;
  height: 22px;
  border-style: none;
}

.ezImages-square-standard-icon-24x24 {
  text-align: left;
  padding: 0;
  margin: 0;
  width: 24px;
  height: 24px;
  border-style: none;
}

.ezImages-square-large-28x28 {
  text-align: left;
  padding: 0;
  margin: 0;
  width: 28px;
  height: 28px;
  border-style: none;
}

.ezImages-square-xlarge-32x32 {
  text-align: left;
  padding: 0;
  margin: 0;
  width: 32px;
  height: 32px;
  border-style: none;
}

.ezImages-micro-icon-8 {
  text-align: left;
  padding: 0;
  margin: 0;
  width: 8px;
  border-style: none;
}

.ezImages-mini-icon-10 {
  text-align: left;
  padding: 0;
  margin: 0;
  width: 10px;
  border-style: none;
}

.ezImages-small-icon-16 {
  text-align: left;
  padding: 0;
  margin: 0;
  width: 16px;
  border-style: none;
}

.ezImages-medium-icon-18 {
  text-align: left;
  padding: 0;
  margin: 0;
  width: 18px;
  border-style: none;
}

.ezImages-normal-icon-22 {
  text-align: left;
  padding: 0;
  margin: 0;
  width: 22px;
  border-style: none;
}

.ezImages-standard-icon-24 {
  text-align: left;
  padding: 0;
  margin: 0;
  width: 24px;
  border-style: none;
}

.ezImages-large-28 {
  text-align: left;
  padding: 0;
  margin: 0;
  width: 28px;
  border-style: none;
}

.ezImages-xlarge-32 {
  text-align: left;
  padding: 0;
  margin: 0;
  width: 32px;
  border-style: none;
}`, "",{"version":3,"sources":["webpack://./public/styles/common/ez-images.css"],"names":[],"mappings":"AAAA;;;iEAAA;AAKA;EACI,YAAA;EACA,kBAAA;EACA,6EAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AAAJ;;AAGA;EACI,YAAA;EACA,kBAAA;EACA,6EAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AAAJ;;AAGA;EACI,YAAA;EACA,kBAAA;EACA,6EAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AAAJ;;AAGA;EACI,aAAA;EACA,kBAAA;EACA,6EAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AAAJ;;AAGA;EACI,UAAA;EACA,SAAA;EACA,WAAA;EACA,sDAAA;EACA,2BAAA;EACA,4BAAA;EACA,wBAAA;AAAJ;;AAGA;EACI,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,qEAAA;EACA,gCAAA;EACA,4BAAA;EACA,0BAAA;AAAJ;;AAGA;EACI,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,6DAAA;EACA,gCAAA;EACA,4BAAA;EACA,0BAAA;AAAJ;;AAGA;EACI,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,6DAAA;EACA,gCAAA;EACA,4BAAA;EACA,0BAAA;AAAJ;;AAGA;EACI,qBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,sCAAA;EACA,mEAAA;EACA,gCAAA;EACA,4BAAA;EACA,0BAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;AAAJ","sourcesContent":["/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| EzClocker Image UX CSS Classes\n| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\n\n.ezImages-avatar-24x24 {\n    height: 24px;\n    border-radius: 3px;\n    background-image: url('/public/images/avatars/ezclocker-engineer-orange.svg');\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.ezImages-avatar-32x32 {\n    height: 32px;\n    border-radius: 3px;\n    background-image: url('/public/images/avatars/ezclocker-engineer-orange.svg');\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.ezImages-avatar-64x64 {\n    height: 64px;\n    border-radius: 3px;\n    background-image: url('/public/images/avatars/ezclocker-engineer-orange.svg');\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.ezImages-avatar-128x128 {\n    height: 128px;\n    border-radius: 3px;\n    background-image: url('/public/images/avatars/ezclocker-engineer-orange.svg');\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.ezImages-small-help {\n    padding: 0;\n    border: 0;\n    width: 18px;\n    background-image: url('/public/images/icons/info.svg');\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: contain;\n}\n\n.ezImages-actiongreen-check-left-container-24x24 {\n    display: inline-block;\n    padding: 0 0 0 30px;\n    min-width: 28px;\n    background-image: url('/public/images/icons/check-ezActionGreen.svg');\n    background-position: left center;\n    background-repeat: no-repeat;\n    background-size: 24px 24px;\n}\n\n.ezImages-black-check-left-container-24x24 {\n    display: inline-block;\n    padding: 0 0 0 30px;\n    min-width: 28px;\n    background-image: url('/public/images/icons/check-black.svg');\n    background-position: left center;\n    background-repeat: no-repeat;\n    background-size: 24px 24px;\n}\n\n.ezImages-black-check-left-container-18x18 {\n    display: inline-block;\n    padding: 0 0 0 30px;\n    min-width: 28px;\n    background-image: url('/public/images/icons/check-black.svg');\n    background-position: left center;\n    background-repeat: no-repeat;\n    background-size: 18px 18px;\n}\n\n.ezImages-hamburger-menu-button {\n    display: inline-block;\n    margin: 2px;\n    padding: 0 0 0 30px;\n    min-width: 24px;\n    min-height: 24px;\n    background-color: var(--ezClockerNavy);\n    background-image: url('/public/images/icons/mobile-menu-white.svg');\n    background-position: left center;\n    background-repeat: no-repeat;\n    background-size: 18px 18px;\n}\n\n.ezImages-square-micro-icon-8x8 {\n    text-align: left;\n    padding: 0;\n    margin: 0;\n    width: 8px;\n    height: 8px;\n    border-style: none;\n}\n\n.ezImages-square-mini-icon-10x10 {\n    text-align: left;\n    padding: 0;\n    margin: 0;\n    width: 10px;\n    height: 10px;\n    border-style: none;\n}\n\n.ezImages-square-small-icon-16x16 {\n    text-align: left;\n    padding: 0;\n    margin: 0;\n    width: 16px;\n    height: 16px;\n    border-style: none;\n}\n\n.ezImages-square-medium-icon-18x18 {\n    text-align: left;\n    padding: 0;\n    margin: 0;\n    width: 18px;\n    height: 18px;\n    border-style: none;\n}\n\n.ezImages-square-normal-icon-22x22 {\n    text-align: left;\n    padding: 0;\n    margin: 0;\n    width: 22px;\n    height: 22px;\n    border-style: none;\n}\n\n.ezImages-square-standard-icon-24x24 {\n    text-align: left;\n    padding: 0;\n    margin: 0;\n    width: 24px;\n    height: 24px;\n    border-style: none;\n}\n\n.ezImages-square-large-28x28{\n    text-align: left;\n    padding: 0;\n    margin: 0;\n    width: 28px;\n    height: 28px;\n    border-style: none;\n}\n\n.ezImages-square-xlarge-32x32 {\n    text-align: left;\n    padding: 0;\n    margin: 0;\n    width: 32px;\n    height: 32px;\n    border-style: none;\n}\n\n.ezImages-micro-icon-8 {\n    text-align: left;\n    padding: 0;\n    margin: 0;\n    width: 8px;\n    border-style: none;\n}\n\n.ezImages-mini-icon-10 {\n    text-align: left;\n    padding: 0;\n    margin: 0;\n    width: 10px;\n    border-style: none;\n}\n\n.ezImages-small-icon-16 {\n    text-align: left;\n    padding: 0;\n    margin: 0;\n    width: 16px;\n    border-style: none;\n}\n\n.ezImages-medium-icon-18 {\n    text-align: left;\n    padding: 0;\n    margin: 0;\n    width: 18px;\n    border-style: none;\n}\n\n.ezImages-normal-icon-22 {\n    text-align: left;\n    padding: 0;\n    margin: 0;\n    width: 22px;\n    border-style: none;\n}\n\n.ezImages-standard-icon-24 {\n    text-align: left;\n    padding: 0;\n    margin: 0;\n    width: 24px;\n    border-style: none;\n}\n\n.ezImages-large-28 {\n    text-align: left;\n    padding: 0;\n    margin: 0;\n    width: 28px;\n    border-style: none;\n}\n\n.ezImages-xlarge-32 {\n    text-align: left;\n    padding: 0;\n    margin: 0;\n    width: 32px;\n    border-style: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
